<!-- レシート表示画面 -->
<template>
  <div id="container" class="vQrCode vDownloadQrCode">
    <!-- メッセージモーダル -->
    <MessageDialog :name="dialogs.msgDialog.name" :title="dialogs.msgDialog.title" :text="dialogs.msgDialog.text" @event-dialog-close="closeCompleteModal">
    </MessageDialog>
    <!-- エラーメッセージモーダル -->
    <MessageDialog :name="dialogs.msgErrorDialog.name" :title="dialogs.msgErrorDialog.title" :text="dialogs.msgErrorDialog.text" @event-dialog-close="closeModal">
    </MessageDialog>
    <HeaderLogo></HeaderLogo>
    <main class="contents entry">
      <ContentsTop :title="contentsTop.title" :text="contentsTop.text"></ContentsTop>
      <form class="mainForm">
        <div class="qr_img">
          <img :src="qrImage">
        </div>
        <table class="detail_table">
          <tbody>
            <tr>
              <th>直近の入国日：</th>
              <td>{{ labels.getDateLabel(certificate.landDate) }}</td>
            </tr>
            <tr>
              <th>証明書の種類：</th>
              <td>{{ labels.getTypeLabel(certificate.type) }}</td>
            </tr>
            <tr>
              <th>発行日：</th>
              <td>{{ labels.getDateLabel(certificate.issueDate) }}</td>
            </tr>
            <tr>
              <th>国外に住所を定めた日：</th>
              <td>{{ labels.getDateLabel(certificate.livingDate) }}</td>
            </tr>
            <tr>
              <th>本籍地：</th>
              <td>{{ certificate.domicile }}</td>
            </tr>
            <tr v-if="Number(certificate.type) === 2">
              <th>発行元公館名：</th>
              <td>{{ certificate.source }}</td>
            </tr>
            <tr v-if="Number(certificate.type) === 2">
              <th>発行番号：</th>
              <td>{{ certificate.number }}</td>
            </tr>
          </tbody>
        </table>
        <div class="sendBtn_box">
          <a @click="download()" class="sendBtn backorange next">お客様のスマホに保存する</a>
        </div>
      </form>
      <div class="caution">{{ caution }}</div>
    </main>
    <Footer></Footer>
  </div>
</template>
<style>
@import "../assets/css/create_qr_code.css";
@import "../assets/css/download_qr_code.css";
</style>
<script>
import common from '@/components/Common.vue';
import HeaderLogo from '@/components/HeaderLogo.vue';
import Footer from '@/components/Footer.vue';
import ContentsTop from '@/components/ContentsTop.vue';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';
import Labels from '../utils/labels';
import MessageDefine from '../utils/messages';
import QrCodeModel from '../utils/qrCode';
import QRCode from 'qrcode-generator';

export default {
  name: 'DownloadQrCode',
  mixins: [common],
  components: {
    HeaderLogo,
    Footer,
    ContentsTop,
    MessageDialog,
  },
  data() {
    return {
      certificate: {},
      qrImage: '',
      qrCodeModel: QrCodeModel,
      labels: Labels,
      messageDefine: MessageDefine,

      dialogs: {
        msgDialog: {
          name: 'msgDialog',
          title: MessageDefine.title.info,
          text: [''],
        },
        msgErrorDialog: {
          name: 'msgErrorDialog',
          title: MessageDefine.title.error,
          text: [''],
        },
      },
      contentsTop: {
        title: MessageDefine.title.qrCode,
        text: MessageDefine.body.downloadQrCodeTop,
      },
      caution: MessageDefine.body.caution,
    };
  },
  created() {
    this.certificate = this.$store.getters.getCertificateInfo;
    // console.log(this.certificate);
    this.createQRCode();
  },
  methods: {
    /**
     * 確認モーダルを閉じる
     */
    closeModal() {
      this.$modal.hide('msgDialog');
      this.$modal.hide('msgErrorDialog');
    },
    /**
     * 確認モーダルを閉じる
     */
    closeCompleteModal() {
      this.$modal.hide('msgDialog');
      this.prev();
    },
    /**
     * QRコード作成
     */
    createQRCode() {
      // 証明書情報をエンコードして、QRコードに登録する
      const {
        landDate,
        type,
        issueDate,
        livingDate,
        domicile,
        source,
        number,
      } = this.certificate;
      const params = {
        landDate,
        type,
        issueDate,
        livingDate,
        domicile,
      };
      if (Number(params.type) === 2) {
        params.source = source;
        params.number = number;
      }

      const encoded = btoa(encodeURIComponent(JSON.stringify(params)));
      const { header, body } = this.qrCodeModel.createQrHeaderAndQrBody(encoded, landDate);
      // ヘッダーとボディーをドットで連結
      const str = `${btoa(encodeURIComponent(JSON.stringify(header)))}.${body}`;
      const qr = QRCode(0, 'L');
      qr.addData(str);
      qr.make();
      this.qrImage = qr.createDataURL(0, 5);
    },
    /**
     * QRコードのダウンロード
     */
    async download() {
      try {
        const image = await fetch(this.qrImage);
        const imageBlob = await image.blob();
        const imageURL = URL.createObjectURL(imageBlob);
        const link = document.createElement('a');
        link.href = imageURL;
        link.download = `海外在住証明QRコード_.${this.$moment().format('YYYYMMDDHHmmss')}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.dialogs.msgDialog.text = this.messageDefine.body.downloadComplete;
        this.$modal.show('msgDialog');
      } catch (error) {
        console.error(error);
        this.dialogs.msgErrorDialog.text = this.messageDefine.body.downloadError;
        this.$modal.show('msgErrorDialog');
      }
    },
  },
};
</script>
